var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23125 3.6C7.23125 5.58584 5.61709 7.2 3.63125 7.2C1.65072 7.2 0.0365597 5.58584 0.03125 3.6C0.03125 1.61416 1.64541 0 3.63125 0C5.61709 0 7.23125 1.61416 7.23125 3.6ZM5.41001 3.6C5.41001 2.6177 4.61355 1.82124 3.63125 1.82124C2.65426 1.82124 1.8578 2.6177 1.8578 3.6C1.8578 4.5823 2.65426 5.37876 3.63125 5.37876C4.61355 5.37876 5.41001 4.5823 5.41001 3.6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23125 13.0088C7.23125 14.9947 5.61709 16.6088 3.63125 16.6088C1.65072 16.6088 0.0365597 14.9947 0.03125 13.0088C0.03125 11.023 1.64541 9.40881 3.63125 9.40881C5.61709 9.40881 7.23125 11.023 7.23125 13.0088ZM5.41001 13.0088C5.41001 12.0265 4.61355 11.2301 3.63125 11.2301C2.65426 11.2301 1.8578 12.0265 1.8578 13.0088C1.8578 13.9911 2.65426 14.7876 3.63125 14.7876C4.61355 14.7876 5.41001 13.9911 5.41001 13.0088Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.23125 22.4177C7.23125 24.4036 5.61709 26.0177 3.63125 26.0177C1.65072 26.0177 0.0365597 24.4036 0.03125 22.4177C0.03125 20.4319 1.64541 18.8177 3.63125 18.8177C5.61709 18.8177 7.23125 20.4319 7.23125 22.4177ZM5.41001 22.4177C5.41001 21.4354 4.61355 20.639 3.63125 20.639C2.65426 20.639 1.8578 21.4354 1.85249 22.4177C1.85249 23.4001 2.64895 24.1965 3.63125 24.1965C4.61355 24.1965 5.41001 23.4001 5.41001 22.4177Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3457 3.43012C9.3457 3.93454 9.75455 4.34339 10.259 4.34339H23.0554C23.5599 4.34339 23.9687 3.93454 23.9687 3.43012C23.9687 2.9257 23.5599 2.51685 23.0554 2.51685H10.259C9.75455 2.51685 9.3457 2.9257 9.3457 3.43012Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0837 13.9168H22.8802C23.3846 13.9168 23.7935 13.508 23.7935 13.0089C23.7935 12.5044 23.3846 12.0956 22.8802 12.0956H10.0837C9.57932 12.0956 9.17578 12.5044 9.17578 13.0089C9.17578 13.5133 9.57932 13.9168 10.0837 13.9168Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0837 23.331H22.8802C23.3846 23.331 23.7935 22.9222 23.7935 22.423C23.7935 21.9239 23.3846 21.5098 22.8802 21.5098H10.0837C9.57932 21.5098 9.17578 21.9186 9.17578 22.423C9.17578 22.9275 9.57932 23.331 10.0837 23.331Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.28165d59.svg";
export { ForwardRef as ReactComponent };